<template lang="html">
    <section :class="'wrapper'">
        <div class="notify mt-5" :class="{'notify-expand' : expand}">
            <div class="header main">
                <img class="app_icon" :src="appIcon" />
                <div class="app">כאן</div>
                <div class="app app-point">• 1m</div>
    
                <div class="space"></div>
    
                <div class="expand" @click="expand = !expand">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg" :class="{'expand-invert' : expand}">
                        <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                    </svg>
    
                    <div v-if="!expand " class="app">today</div>
                    <div v-if="expand" class="app">X</div>
                </div>
    
            </div>
    
            <img v-if="notification.image && expand" class="image-expand" :src="notification.image" />
    
    
    
            <div class="header">
    
    
                <div class="content">
                    <div class="notifytitle">{{notification.title}}</div>
                    <div class="body" :class="{'body-expand' : !notification.image || expand}">{{notification.body}}</div>
                </div>
                <a :href="notification.image" target="_blank">
                     <img ref="image" v-if="notification.image && !expand" class="image" :src="notification.image" @load="imageLoaded" />
                    </a>
            </div>
        </div>
    </section>
</template>

<script lang="js">
export default {
    name: 'notifyIOS',
    mounted() {

    },
    data() {
        return {
            expand: false
        }
    },
    methods: {
        imageLoaded(img) {
            this.notification.imageAspectRatio = this.$refs.image.naturalHeight / this.$refs.image.naturalWidth
        }
    },
    computed: {
        notification() {
            return this.$store.getters.notification
        },
        appIcon() {
            return `/img/icons/app_logo_${this.$route.params.app}.png`
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    justify-content: center;
    height: 200px;
    width: 95%;
}

.notify {
    border-radius: 10px;
    background-color: #ffffffaa;
}

.app-point,
.v-icon__svg {
    display: none;
}

.main {
    height: 30px;
}

.image-expand {
    margin-top: 15px;
    margin-bottom: 15px;
    height: 130px;
}

.space {
    flex: 1 1 auto;
}

.notify {
    height: 100px;
    width: 88%;
    background-color: #ffffff;
    color: black;
    transition: height 0.25s ease-in;
    overflow: hidden;
}

.notify-expand {
    height: 270px;
    transition: height 0.25s ease-in;
}

.header {
    display: flex;
    margin-bottom: 2px;
    padding-right: 12px;
    padding-left: 12px;
}

.main {
    padding-top: 12px;
}

.notifytitle {
    font-size: 14px;
    font-weight: bolder;
}

.expand-invert {
    transform: rotate(-180deg);
}

.expand {
    cursor: pointer;
}

.body {
    width: 200px;
    font-size: 13px;
    transition: height 0.25s ease-in;
}

.body-expand {
    height: 130px;
    width: 100%;
    transition: height 0.25s ease-in;
    white-space: normal;
}

.app {
    color: gray;
    margin-right: 5px;
    font-size: 12px;
}

.image {
    height: 50px;
    width: 50px;
    flex: 0 0 50px;
    object-fit: cover;
}

.image-expand {
    height: 150px;
    width: 100%;
    object-fit: cover;
}

.content {
    flex: auto;
}

.app_icon {
    height: 15px;
    width: 15px;
    outline: 0.5px solid grey;
}
</style>
